import React from 'react';

import type { TagEntity } from '@schibsted/frapi-schema';

import { usePulseContext } from '../../../../core/mandatory-integrations/pulse/PulseProvider.js';
import { formatTag } from './helpers.js';

type FilterButtonProps = {
  tag: TagEntity;
  handleClick: (tag: TagEntity) => void;
  active?: boolean;
  isCheckbox?: boolean;
};

export const FilterButton: React.FC<FilterButtonProps> = ({
  tag,
  active = false,
  handleClick,
  isCheckbox = false,
}) => {
  const classNames = [
    'filter-button',
    active ? 'active' : '',
    isCheckbox ? 'checkbox' : '',
  ].join(' ');
  const tagTitle = formatTag(tag.title);
  const { trackClickUIElement } = usePulseContext();

  const handleActiveButton = (event: React.MouseEvent): void => {
    event.preventDefault();

    // TODO: Tag props needed? Custom schemm?
    trackClickUIElement(
      {
        object: {
          id: 'filter:add-filter',
          elementType: 'Button',
          name: `${active ? 'deactivate' : 'activate'} filter button`,
          custom: {
            tagId: tag.id,
            tagTitle: tag.title,
          },
        },
      },
      {
        object: {
          objectId: 'filter:add-filter',
          elementType: 'Button',
          name: `${active ? 'deactivate' : 'activate'} filter button`,
        },
        placement: { containerName: 'page' },
      },
    );

    handleClick(tag);
  };

  return (
    <button className={classNames} onClick={handleActiveButton}>
      {tagTitle}
    </button>
  );
};
